import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ImageGrid } from "@faire/retailer-visitor-shared/components/ImageGrid";
import { useFetchSingleBoard } from "@faire/retailer-visitor-shared/features/RetailerBoards/hooks/boardsHooks";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { createToast, dismissToast } from "@faire/web--source/slate/Toast/Toast";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import singleRetailerBoard from "@faire/web-api--source/routes/boards/retailerBoardToken";
import React from "react";
import styled from "styled-components";
export var SaveToBoardToast = function(props) {
    var boardToken = props.boardToken, productImage = props.productImage, onChangeBoardClick = props.onChangeBoardClick, boardItemIsMoving = props.boardItemIsMoving;
    var board = useFetchSingleBoard(boardToken).board;
    var _board_cover_images;
    return /*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(StyledImageGrid, {
                images: (_board_cover_images = board === null || board === void 0 ? void 0 : board.cover_images) !== null && _board_cover_images !== void 0 ? _board_cover_images : [
                    productImage
                ],
                imageSize: 64
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "2x"
            }),
            /*#__PURE__*/ _jsxs(ContentWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.inverse,
                        children: boardItemIsMoving ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "5zsmLi",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Moved to"
                                }
                            ]
                        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "F8GKjw",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Saved to"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        linkTo: singleRetailerBoard(boardToken !== null && boardToken !== void 0 ? boardToken : ""),
                        style: {
                            width: "fit-content",
                            textDecoration: "none"
                        },
                        tertiaryColor: Core.text.inverse,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            color: Core.text.inverse,
                            variant: "paragraphSansMedium",
                            truncate: true,
                            children: board === null || board === void 0 ? void 0 : board.name
                        })
                    }),
                    onChangeBoardClick ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "tertiary",
                                tertiaryColor: Core.text.inverse,
                                style: {
                                    alignSelf: "flex-start"
                                },
                                onClick: function() {
                                    return onChangeBoardClick === null || onChangeBoardClick === void 0 ? void 0 : onChangeBoardClick();
                                },
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "uaw4PO",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Choose different board"
                                        }
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
var ContentWrapper = styled(Column).withConfig({
    componentId: "sc-fae2e06e-0"
})([
    "min-width:150px;"
]);
var StyledImageGrid = styled(ImageGrid).withConfig({
    componentId: "sc-fae2e06e-1"
})([
    "width:98px;"
]);
var activeToastId = "";
export var showSaveToBoardToast = function(props) {
    closeSaveToBoardToastIfActive();
    createToast(/*#__PURE__*/ _jsx(SaveToBoardToast, _object_spread({}, props)), {
        timeout: "long",
        onOpen: function(toastId) {
            var _getWindow;
            activeToastId = toastId;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("scroll", handleScrollWhenToastIsActive, {
                passive: true
            });
        }
    });
};
export var closeSaveToBoardToastIfActive = function() {
    if (activeToastId) {
        dismissToast(activeToastId);
        activeToastId = "";
    }
};
var handleScrollWhenToastIsActive = throttleIfPossible(function() {
    var _getWindow;
    closeSaveToBoardToastIfActive();
    (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("scroll", handleScrollWhenToastIsActive);
}, 50);
